import axios from 'axios'

const mutations = {
   SET_SCROLLTOP: (state, { scrollTop }) => {
      state.scrollTop = scrollTop
   },
   SET_WIDTH: (state, { width }) => {
      state.width = width
   },
   SET_MOBILE: (state, { isMobile }) => {
      state.isMobile = isMobile
   },
   SET_STATE: (state, { prop, value }) => {
      state[prop] = value
   }
};

const actions = {
   SET_SCROLLTOP({ commit }, top) {
      if (top) {
         commit('SET_SCROLLTOP', { scrollTop: top })
      }
   },
   SET_WIDTH({ commit }, width) {
      if (width) {
         commit('SET_WIDTH', { width: width })
      }
   },
   SET_MOBILE({ commit }, isMobile) {
      if (isMobile) {
         commit('SET_MOBILE', { isMobile: isMobile })
      }
   },
   SET_STATE({ commit }, obj) {
      var value = Object.values(obj)[0];
      var prop = Object.keys(obj);
      commit('SET_STATE', { prop: prop, value: value })
   }
};


const getters = {
   getScrollTop: state => {
      return state.scrollTop
   },
   getWidth: state => {
      return state.width
   },
   getMobile: state => {
      return state.isMobile
   },
   getState: state => prop => {
      return state[prop]
   }
};

const state = {
   scrollTop: 0,
   width: window.innerWidth
};

export default {
   namespaced: true,
   actions,
   getters,
   state,
   mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js